exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "div.draggable-item img.drag-icon {\n  padding-top: 7px;\n  padding-right: 7px;\n  float: right; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./client/modules/core/Draggable/style.scss
// module id = 1038
// module chunks = 0